import React, { useContext, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { TakeoverLayout } from '_lex/_layouts/TakeoverLayout';
import { enqueueSnackbar } from 'notistack';
import { translate as t } from 'hooks/useTranslations';
import { AppContext } from 'views/App/context';
import { useQueryClient } from 'react-query';
import { ServerErrorResponse } from 'data_sources/constants';
import useManageEisRules from '../_data_sources/useManageEisRules';
import type { CreateEisRuleRequest } from '../_types';
import RuleForm from '../_components/RuleForm';

const CreateRule: React.FC = () => {
  const navigate = useNavigate();
  const { hasPermission, currentOrganizationId } = useContext(AppContext);
  const { createRule } = useManageEisRules();
  const queryClient = useQueryClient();
  const [serverErrors, setServerErrors] = useState<ServerErrorResponse>();

  const handleCreate = async (formData: CreateEisRuleRequest) => {
    await createRule(
      formData,
      (response) => {
        enqueueSnackbar(t('performanceReporting.eis.create.success'), {
          variant: 'success',
          autoHideDuration: 3000,
        });
        queryClient.invalidateQueries(['eisRules']);
        navigate(`../configuration/${response.id}`);
      },
      (error) => {
        setServerErrors(error);
      }
    );
  };

  useEffect(() => {
    if (!hasPermission('manageFieldBank', currentOrganizationId || '')) {
      navigate('/admin/performance-reporting/early-intervention-system');
    }
  }, [hasPermission, currentOrganizationId, navigate]);

  return (
    <TakeoverLayout
      pageTitle={t('performanceReporting.eis.create.pageTitle')}
      backUrl='..'
    >
      <Box>
        <RuleForm
          onCreate={handleCreate}
          onCancel={() => navigate('..')}
          serverErrors={serverErrors}
          setServerErrors={setServerErrors}
        />
      </Box>
    </TakeoverLayout>
  );
};

export default CreateRule;
